module.exports = __webpack_public_path__ + "img/FiveStarPro.978fb9e1.svg";